/**
 * @description Default values for react-hook-form forms used for each result page (travels, leisures, sport)
 */

export const travelDefaultValues = {
  tourOperatorId: { label: 'Touloisirs', value: 'touloisirs', id: 'touloisirs' },
  country: '',
  departure: '',
  dates: [null, null],
  category: [],
  package: [],
  nights: []
};

export const leisureDefaultValues = {
  subsidizedOffers: false,
  keywords: '',
  place: '',
  /**
   * each key in leisureCategory corresponds to the category Code
   * each value in leisureCategory corresponds to the subcategory Codes of the category
		example: leisureCategory: {
			[category]: [subcategory1, subcategory2]
			'CN': ['AB', 'AV]
		}
   */
  leisureCategory: {}
};

export const sportDefaultValues = {
  sportCategory: {},
  dates: [null, null],
  place: ''
};

export const giftcardDefaultValues = {
  keywords: '',
  category: []
};
